import { createContext } from 'preact';

export type ConveyorBeltContextProps = {
  setCurrentItem?: (node: HTMLElement | null) => void;
  activeItemId?: string;
  setActiveItemId?: (id: string) => void;
};

export const ConveyorBeltContext = createContext<ConveyorBeltContextProps>({});
